
import { defineComponent, computed, ref, onMounted } from 'vue';
import { useStore } from '@/store';
import { lowerCaseIncludes, exportToDrive } from '@/utils';
import BidsTable from '@/components/tables/BidsTable.vue';
import ButtonInput from '@/components/form-controls/base/ButtonInput.vue';
import TextInput from '@/components/form-controls/base/TextInput.vue';
import MaterialIconButton from '@/components/form-controls/MaterialIconButton.vue';
import { useRouter, useRoute } from 'vue-router';
import { Bid } from '@/types/app';

export default defineComponent({
  name: 'BidsManager',
  components: {
    BidsTable,
    MaterialIconButton,
    TextInput,
    ButtonInput
  },
  setup() {
    const store = useStore();
    const searchValue = ref('');
    const bids = computed(() => store.getters.bids.get);

    const filteredBids = computed(() => {
      const searchTerms = searchValue.value.split(/\s+/).filter(term => term);

      return bids.value.filter(bid => {
        return searchTerms.every(
          term =>
            lowerCaseIncludes(bid.client.name, term) ||
            lowerCaseIncludes(bid.client.email, term) ||
            lowerCaseIncludes(bid.jobName, term) ||
            lowerCaseIncludes(bid.jobLocation, term)
        );
      });
    });

    const sortedBids = computed(() =>
      filteredBids.value.slice().sort((a, b) => {
        if (a.client.name < b.client.name) return -1;
        if (b.client.name < a.client.name) return -1;
        return 0;
      })
    );

    const router = useRouter();
    const clearBidAndPushCreateRoute = () => {
      // @ts-expect-error Direct Vuex wants a payload for the generic action.
      // Custom modules are not correctly typed at the moment.
      // This action does not accept a payload.
      store.dispatch.bids.clearLocalBid();
      router.push('/create');
    };

    const route = useRoute();
    onMounted(() => {
      searchValue.value = (route.query.q || '').toString();
    });

    const editBid = (bid: Bid) => {
      store.dispatch.bids.updateLocalBid(bid);
      store.dispatch.internal.update(['linkedClientSelect', bid.client]);
      store.dispatch.internal.update(['jobName', bid.jobName]);
      store.dispatch.internal.update(['linkedLocation', bid.materialList[0].location.geoPoint]);
      router.push('/create/bid');
    };

    return {
      searchValue,
      sortedBids,
      clearBidAndPushCreateRoute,
      editBid,
      exportToDrive
    };
  }
});
